<template>
    <div :class="['hpStart', 'reveal active']" style="width:100%;">
        <div class="container">
            <!--<img class="startLogo" src="/img/cancun/hp-middle-logo.png" alt="" />-->
            <div class="motionWrapper">
                <div id="hpMotionLoader1" class="hpMotionLoader"><div class="col1"></div><div class="col2"></div><div class="col3"></div></div>
                <div id="hpMotion1" :class="['motionContainer']"></div>
            </div>
            <div class="hpTextWrapper">
                <!--<div class="split-text subtitle t2"><p>September 12-15, 2024</p></div>-->                
                <!-- <div class="split-text title t1">JOIN US</div>   -->

                 <div :class="['hpCountdown', showCountdown ? 'visible':'']">
                    <div class="hpCountdownElement" 
                        :style="'--index:'+tIndex"
                        v-for="(timeItem,tIndex) in timeElements" :key="'time_'+tIndex">                                                
                        <div class="digits">
                            <template v-if="timeItem.val<10">0</template>{{timeItem.val}}                            
                        </div>                        
                        <div class="name">{{timeItem.name}}</div>
                        <br/><br/>
                    </div>
                </div>
 
                <div class="split-text intro-text">
                    Join us for a unique opportunity to connect and experience the 
                    vibrant energy of the MIS community!
                </div>  
                

                <!--
                    <div class="xrBtn"  v-if="isMainVersion===false">
                    <a class="base_btn orange_btn animation_up" target="_blank" 
                    href="https://mis.forms-wizard.biz/">
                    <span class="title">Fees & Registration</span><i class="fal fa-chevron-right pl-s" ></i>
                    </a>
                </div>                
                -->            
            </div>
        </div>
    </div>
</template>




<script>
import { mapActions, mapState } from "vuex";
//import { splitLines }         from "@/utils";

export default {
  data() {
    return {
        timeElements:[],
        showCountdown:false,
        isMotionLoaded:false
    }
  },
  mounted() 
  {
    var vm = this;    
    vm.startAnimation();///<<<this will load the lotty file

    this.setCountdown();
    setTimeout(() => {
        vm.showCountdown = true;
    }, 700);
  },
  methods: 
  {    
    setCountdown()
    {
        var vm = this;
        vm.timeElements = [];

        //var date1 = new Date("2/Feb/2024 14:30:00");///test date
        var date1 = new Date();
        console.log("date1="+date1);

        //GET TIME IN LOCATION (PALMA IS UTC+1)
        const d = new Date();
        const localTime = d.getTime();
        const localOffset = d.getTimezoneOffset() * 60000;
        const utc = localTime + localOffset;
        const offset = 1; // UTC of PALMA Time Zone is +1
        const locationTime = utc + (3600000 * offset);
        const targetLocationTimeNow = new Date(locationTime);//.toLocaleString();
        console.log("targetLocationTimeNow="+targetLocationTimeNow);
        date1 = targetLocationTimeNow;//new Date(dateString + "T10:00:00");
        //alert("date1="+date1);

        //var date2 = Date.parse("12 Sep 2024 10:00:00 GMT");
        const dateString = '2024-09-12'
        var date2 = new Date(dateString + "T10:00:00");
        console.log("date2="+date2);

        //const javaScriptRelease = Date.parse('04 Dec 1995 00:12:00 GMT');

        var diff = date2.getTime() - date1.getTime();
        console.log("diff="+diff);

        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        diff -=  days * (1000 * 60 * 60 * 24);

         var hours = Math.floor(diff / (1000 * 60 * 60));
        diff -= hours * (1000 * 60 * 60);

        var mins = Math.floor(diff / (1000 * 60));
        diff -= mins * (1000 * 60);

        var seconds = Math.floor(diff / (1000));
        diff -= seconds * (1000);

        //alert(days + " days, " + hours + " hours, " + mins + " minutes, " + seconds + " seconds");
        
        var months = 0;
        if(days>=30)
        {
            months = Math.floor(days/30);
            days = days - (months * 30);
        }

        var weeks = 0;
        if(days>7)
        {
            weeks = Math.floor(days/7);
            days = days - (weeks * 7);
        }

        console.log("months="+months);
        console.log("weeks="+weeks);
        console.log("days="+days);

        if(months>0)
        {
            //show month/weeks/days
            vm.timeElements.push({"name":"Months","val":months});
            vm.timeElements.push({"name":"Weeks","val":weeks});
            vm.timeElements.push({"name":"Days","val":days});
        }else
        {
            if(weeks>0)
            {
                //show weeks/days/hours                
                vm.timeElements.push({"name":"Weeks","val":weeks});
                vm.timeElements.push({"name":"Days","val":days});
                vm.timeElements.push({"name":"Hours","val":hours});
            }
            else
            {
                if(days>0)
                {
                    //days,hours,minutes                    
                    vm.timeElements.push({"name":"Days","val":days});
                    vm.timeElements.push({"name":"Hours","val":hours});
                    vm.timeElements.push({"name":"Minutes","val":mins});
                }
                else
                {
                    //hours/min/sec                    
                    vm.timeElements.push({"name":"Hours","val":hours});
                    vm.timeElements.push({"name":"Minutes","val":mins});
                    vm.timeElements.push({"name":"Seconds","val":seconds});

                    if(seconds<1 && mins<1 && hours==0)
                    {
                        //boooooom ?
                    }
                }
            }
        }
        //alert("months:"+months+" weeks:"+weeks+" days:"+days);
    },

    startAnimation()
    {
        var vm = this;
        var anim;
        var animPath = "img/seashell_main3.json";
        var animData = {
            // animationData: { /* ... */ },
            container: document.getElementById('hpMotion1'), // required
            path: animPath,
            renderer: 'svg', // required
            loop: true, // optional
            autoplay: true, // optional
            name: "startAnimation", // optional
        };
        anim = bodymovin.loadAnimation(animData);
        anim.addEventListener('DOMLoaded', function(e) 
        { 

            document.getElementById("hpMotionLoader1").style.display = "none";
            let motionElement= document.getElementById("hpMotion1");//fade in the motion container
            motionElement.style.display = "initial";
            setTimeout(() => {
                motionElement.classList.add("vis");    
            }, 300);
            
            

            //Add preloader animation in the middle of the screen
            //https://codepen.io/alphardex/pen/XWWWBmQ
            //alert('DOM loaded'); 
            //start the page when loaded 
        });
    }
  },
  computed: {
    ...mapState(["pageLayoutData", "locale", "dirtyHome"]),
    isMainVersion()
    {
        return this.$route.path.toLowerCase() == "/v2" ? false : true;
    }
  }
};
</script>



<style>
    .hpCountdown
    {
        display: grid;
        justify-items: center;
        grid-template-columns: repeat(3, minmax(100px, 1fr));  
        clear:both;
        margin:auto;
        width:30vw;
        max-width: 300px;
        column-gap: 0px;        
    }

    .hpCountdown .hpCountdownElement
    {
        width: 100%;
        max-height: 90px;        
        transition-delay: calc(var(--index) * 0.3s);
        transition: opacity ease 0.4s;
        opacity: 0;
    }
    .hpCountdown.visible .hpCountdownElement
    {
        opacity: 1;
    }

    .hpCountdownElement:nth-child(1) div {color:#3fa6cd;}
    .hpCountdownElement:nth-child(2) div {color:#cb8788;}
    .hpCountdownElement:nth-child(3) div {color:#f17f77;}
    .hpCountdownElement .digits
    {
        font-size: 56px;
        line-height: 56px;
        letter-spacing: -3px;
    }
    .hpCountdownElement .name
    {
        padding-top: 4px;
        font-size: 12px;
        line-height: 12px;
    }


    .hpStart .motionWrapper
    {
        width: 800px;height:300px;
        max-width: 100vw;
        margin: auto;
    }    
    .hpStart .hpMotionLoader
    {
        margin: auto;
        width: 50%;
        height: 300px;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0;
        animation-delay: 1s;
        animation: fade_preloader 0.3s 1s forwards;
    }
    .hpStart .hpMotionLoader > div {
        width: 20px;
        height: 20px;
        border-radius: 100%;
        margin: 10px;
        animation: bounce 1.5s 0.5s linear infinite;
    }
    .hpStart .hpMotionLoader .col1 {
        background-color: #fad74e;
    }
    .hpStart .hpMotionLoader .col2 {
        background-color: #50baa6;animation-delay: 0.1s;
    }
    .hpStart .hpMotionLoader .col3 {
        background-color: #36abdf;animation-delay: 0.2s;
    }
    @keyframes fade_preloader
    {
        from {opacity: 0;}
        to {opacity: 1;}  
    }
    @keyframes bounce {
        0%, 50%, 100% {
            transform: scale(1);
            filter: blur(0px);
        }
        25% {
            transform: scale(0.6);
            filter: blur(3px);
        }
        75% {
            filter: blur(3px);
            transform: scale(1.4);
        }
    }
    #hpMotion1
    {
        opacity: 0;
        transition: all ease 0.4s;
        transition-delay: 0.3s;
    }
    #hpMotion1.vis
    {
        opacity: 1;
    }


    .hpStart .container
    {
      width: 100%;
      position: relative;
      top: -80px;
    }    
    .hpStart .motionContainer
    {
        display: none;
        width: 800px;height:300px;
        max-width: 100vw;
        margin: auto;
        opacity: 0;
        transition: all ease-in 0.3s;
        transition-delay: 0.1s;
    }
    .hpStart .testImg
    {
        width: auto;height:300px;
        max-width: 100vw;
        margin: auto;
    }    
    .hpStart.reveal.active .motionContainer{
        opacity: 1;
    }
    .hpStart .motionContainer.motionLoaded{
        display: initial;
    }

    .hpTextWrapper
    {
        width: 700px;
        margin: auto;
    }
    .hpStart.reveal .startLogo{
        width: 500px;height:auto;
        clip-path: circle(1px at center);
        transform: scale(1.1);
        opacity: 0;
        padding-bottom: 10px;
    }
    .hpStart.reveal.active .startLogo{
        animation: hpOpenLogo 2.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        animation-fill-mode:forwards;        
        animation-delay: 0.2s;
    }
    @keyframes hpOpenLogo {
        from {clip-path: circle(1px at center);opacity: 0;transform: scale(0.95);}  
        to {clip-path: circle(450px at center);opacity: 1;transform: scale(1);}
    }  


    .hpStart .t1{
        font-size: 80px !important;
        letter-spacing: -5px !important;
        font-weight: 100 !important;
        color: #fff;
        line-height: 82px  !important;
    }
    .hpStart .t2{
        font-size: 24px;color: #9ddbf2;
        font-weight: 100 !important;        
    }

    .hpStart .split-text.title{
      padding-bottom: 0px !important;
    }
    .hpStart .t2 .xLineText{
        font-size: 27px !important;
        line-height: 27px;
        color: #9ddbf2;
        font-weight: 100 !important;
    }

    .hpStart .intro-text
    {
        width: 40vw;
        padding-top: 10px;
        font-weight: 200 !important;
        font-size: 20px;
        line-height: 22px;
        margin: auto;
    }
    .hpStart.reveal.active .intro-text div,
    .hpStart .intro-text div
    {      
      font-weight: 200 !important;
      font-size: 20px;
      line-height: 25px;
    }
    .hpStart.reveal.active .intro-text div, 
    .hpStart .intro-text div
    {
        letter-spacing: -1px;
    }



    @media only screen and (min-width: 1800px) 
    {
        .hpCountdown {
            grid-template-columns: repeat(3, minmax(120px, 1fr));
            width: 360px;
            max-width: 360px;
        }        
        .hpCountdown .hpCountdownElement {
            max-height: 120px;
        }        
        .hpCountdownElement .digits {
            font-size: 80px;
            line-height: 80px;
        }        
        .hpCountdownElement .name {
            padding-top: 4px;
            font-size: 18px;
            line-height: 18px;
        }        
        .motionWrapper
        {
            width: 50vw !important;
            height: 25vw !important;
            position: relative;
            top: -2vw;            
        }    
        .hpTextWrapper
        {
            width: 50vw;
            position: relative;
            top: -2vw;
        }
        .hpStart.reveal.active .intro-text div,
        .hpStart .intro-text{
            font-size: clamp(16px, 1.5vw, 37px) !important;
            line-height: normal;
            width: 40vw;
        }
    }

    @media (max-width: 850px) { 
        .hpCountdown {
            grid-template-columns: repeat(3, minmax(80px, 1fr));
            width: 240px;
            max-width: 240px;
        }
        .hpStart
        {
            position: fixed;
            top:240px
        }
        .hpStart .testImg
        {
            width: 70vw;
            height:auto;
            margin: auto;
        }    

        .hpStart .hpTextWrapper
        {
            padding-top: 5px;
        }
        .hpStart .hpMotionLoader
        {
            width: 50%;
            height: 300px;
        }
        .hpStart .hpMotionLoader > div {
            width: 10px;
            height: 10px;
            margin: 5px;
        }        
        .hpStart .motionWrapper
        {
            width: 100%;
            height: 50vw;
            transform: scale(1.4);
            position: relative;
            left: -4vw;
            top: -8vw;            
        }            
        .hpStart .motionContainer
        {
            width: 100%;
            height: 50vw;
        }
        .hpStart .container
        {
          width: 100%;
        }
        .hpTextWrapper
        {
            width: 80vw;
            margin: auto;
        }
        .hpStart .intro-text
        {
            width: 100%;
            margin: auto;
        }


        .startLogo
        {
          width: 70vw !important;
        }
        .hpStart.reveal.active .t1 div,
        .hpStart .t1{
            font-size: 64px !important;
            line-height: 67px;
        }
        .split-text.subtitle
        {
            padding-bottom: 0px !important;
        }

        .hpStart.reveal.active .t2 div,
        .hpStart .t2 .xLineText{
            font-size: 22px !important;
            color: #9ddbf2;
        }
        .hpStart.reveal.active .intro-text div,
        .hpStart .intro-text{
            font-size: 18px !important;
            line-height: 20px !important;
        }


    }

    @media (max-width: 400px) { 
        .hpStart .t1{
            display: inline;
        }
        .hpStart.reveal.active .t1 div,
        .hpStart .t1 .xLineText{
            font-size: 50px !important;
            line-height: 54px !important;
            letter-spacing: -1px !important;  display: inline;          
        }

        .hpStart.reveal.active .intro-text div,
        .hpStart .intro-text .xLineText{
            font-size: 18px !important;
            line-height: 24px !important;
            letter-spacing: -0.4px;
        }



    }

    /* Portrait iPad mini 1, iPad 1 and iPad 2*/
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: portrait)
    {
        .hpStart .container
        {
        width: 80vw;
        }

    }    





</style>

